import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalPasswordComponent } from './modal-password.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TranslateModule } from '@ngx-translate/core';
// import { IconSpriteModule } from 'ng-svg-icon-sprite';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from '@app/components/components.module';

@NgModule({
  declarations: [ModalPasswordComponent],
  exports: [ModalPasswordComponent],
  imports: [
    CommonModule,
    ComponentsModule,
    FormsModule,
    ModalModule.forRoot(),
    // IconSpriteModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
})
export class ModalPasswordModule {}
